import clsx from 'clsx';

export interface GlassGridBackgroundProps {
  /** 格子宽度，默认96px */
  columnWidth?: number;
  /** 自定义类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
}

/**
 * 毛玻璃格子背景组件
 * 使用CSS实现格子效果，避免边缘裁剪问题
 */
export function GlassGridBackground({
  columnWidth = 96,
  className,
  style,
}: GlassGridBackgroundProps) {
  return (
    <div
      className={clsx('pointer-events-none absolute inset-0 z-0 overflow-hidden', className)}
      style={{
        ...style,
        backgroundImage: 'url(/assets/v2/bg.png)',
        backgroundSize: 'cover',
      }}
    >
      {/* 格子效果层 - 使用CSS背景实现 */}
      <div
        className="absolute inset-x-0 bottom-0 top-[88px]"
        style={{
          // 毛玻璃效果
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          // 垂直渐变叠加
          background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.60) 48.96%, rgba(255, 255, 255, 0.60) 81.13%, rgba(255, 255, 255, 0.00) 100%)`,
        }}
      />
      {/* 竖线效果层 - 使用repeating-linear-gradient */}
      <div
        className="absolute inset-x-0 bottom-0 top-[88px]"
        style={{
          backgroundImage: `repeating-linear-gradient(
            90deg,
            transparent 0px,
            transparent ${columnWidth - 1}px,
            rgba(255, 255, 255, 0.50) ${columnWidth - 1}px,
            rgba(255, 255, 255, 0.50) ${columnWidth}px
          )`,
          // 竖线也需要垂直渐变淡出（只在顶部淡出）
          maskImage: `linear-gradient(180deg, transparent 0%, black 10%, black 100%)`,
          WebkitMaskImage: `linear-gradient(180deg, transparent 0%, black 10%, black 100%)`,
        }}
      />
    </div>
  );
}

export default GlassGridBackground;
